import moment from "moment";
import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { headers, insertUpdateB2BTimeSlotUrl, getB2BTimeSlotDetailsUrl, deleteB2BTimeSlotUrl, INSERT_UPDATE_DELEGATE_B2B_TIMESLOT_ACTION_TYPE, GET_DELEGATE_B2B_TIMESLOT_ACTION_TYPE, DELETE_DELEGATE_B2B_TIMESLOT_ACTION_TYPE } from "../../../utils/constants";


export const insertB2B_TimeSlot_action = (B2B_TimeSlotList) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            // B2B_TimeSlotDate: moment(B2B_TimeSlotDate).format('YYYY-MM-DD'),
            // ReportingTime: moment(ReportingTime, 'HH:mm').format('HH:mm:ss'),
            B2B_TimeSlotList: B2B_TimeSlotList,
        }

        const res = await axiosPost(insertUpdateB2BTimeSlotUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_DELEGATE_B2B_TIMESLOT_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getB2B_TimeSlot_action = (ExhibitionID) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
        }

        const res = await axiosGet(getB2BTimeSlotDetailsUrl, params, headers)

        dispatch({
            type: GET_DELEGATE_B2B_TIMESLOT_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteB2B_TimeSlot_action = (B2BTimeSlotID) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            B2BTimeSlotID: B2BTimeSlotID,
        }

        const res = await axiosGet(deleteB2BTimeSlotUrl, params, headers)

        dispatch({
            type: DELETE_DELEGATE_B2B_TIMESLOT_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}